import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment.development';

@Injectable({
  providedIn: 'root',
})
export class ApiServiceService {
  // @Output("login") ClickInLogin: EventEmitter<any> = new EventEmitter<void>();
  @Output('getCartList') cartClick: EventEmitter<any> =
    new EventEmitter<void>();
  @Output('chackOut') cartClickInCheckOut: EventEmitter<any> =
    new EventEmitter<void>();
  @Output('getWishlist') wishlistClick: EventEmitter<any> =
    new EventEmitter<void>();

  constructor(private http: HttpClient) {}

  register(param: any) {
    const url = `${environment.apiBaseUrl + environment.apiEndPoint.register}`;
    return this.http.post(url, param);
  }

  login(param: any) {
    const url = `${environment.apiBaseUrl + environment.apiEndPoint.login}`;
    return this.http.post(url, param);
  }

  // // In your Angular service file
  // getProductsByCategory(categoryId: any, page: number = 1, limit: number = 12): Observable<any> {
  //   const params = new HttpParams()
  //     .set('page', page.toString())
  //     .set('limit', limit.toString());

  //   const url = `${environment.apiBaseUrl}/GetProductByCategories/${categoryId}`;
  //   return this.http.get(url);
  // }

  getProductsByCategory(
    categoryId: string,
    page: number = 1,
    limit: number = 12,
  ): Observable<any> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());

    return this.http.get(
      `${environment.apiBaseUrl}/GetProductByCategories/${categoryId}`,
      { params },
    );
  }

  // getProductsByCategory(categoryId: string, page: number = 1, limit: number = 12): Observable<any> {
  //   const params = new HttpParams()
  //     .set('page', page.toString())
  //     .set('limit', limit.toString());

  //   return this.http.get(`${this.apiUrl}/categories/${categoryId}/products`, { params });
  // }

  verifyOtp(param: any): Observable<any> {
    const url = `${environment.apiBaseUrl + environment.apiEndPoint.verifyotp}`;
    return this.http.post(url, param);
  }

  resendOtp(param: any): Observable<any> {
    const url = `${environment.apiBaseUrl + environment.apiEndPoint.reSend}`;
    return this.http.post(url, param);
  }

  // getProductById(id: string): Observable<any> {
  //   const url = `${environment.apiBaseUrl}${environment.apiEndPoint.productDetails}/${id}`;
  //   return this.http.get<any>(url);
  // }
  getProductById(productId: string, userId?: string): Observable<any> {
    let params = new HttpParams();

    if (userId) {
      params = params.set('userId', userId);
    }

    return this.http.get<any>(
      `${environment.apiBaseUrl}${environment.apiEndPoint.productDetails}/${productId}`,
      { params },
    );
  }

  // getCatagories(): Observable<any> {
  //   const url = `${environment.apiBaseUrl+environment.apiEndPoint.getCatagories}`;
  //   return this.http.get(url);
  // }

  allActiveProducts(): Observable<any> {
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.allActiveProducts
    }`;
    return this.http.get(url);
  }

  getBanners(): Observable<any> {
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.getBanners
    }`;
    return this.http.get(url);
  }

  getCartList(userId: string): Observable<any> {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No token found in localStorage');
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    const url = `${environment.apiBaseUrl}${environment.apiEndPoint.cartList}/${userId}`;

    return this.http.get(url, { headers });
  }

  addToCart(param: any) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token') as any;
      // const d = JSON.parse(token as any)
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });

      const url = `${
        environment.apiBaseUrl + environment.apiEndPoint.addToCart
      }`;
      this.http.post(url, param, { headers }).subscribe((res: any) => {
        this.cartClick.emit();
        resolve(res);
      });
    });
  }

  updateCart(
    productId: string,
    quantity: number,
    userId: any,
  ): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    const url = `${environment.apiBaseUrl}/cart-update`;
    const body = { product_id: productId, quantity, user_id: userId }; // Send user_id in the body

    return this.http.put(url, body, { headers });
  }

  deleteCartItem(productId: string, userId: string) {
    const token = localStorage.getItem('token'); // Get token from storage
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    return this.http.delete(
      `${
        environment.apiBaseUrl + environment.apiEndPoint.deleteCartItem
      }/${userId}/delete`,
      {
        headers,
        body: { product_id: productId }, // Pass product_id in the request body
      },
    );
  }

  changePassword(param: any): Observable<any> {
    const token = localStorage.getItem('token') as any;
    // const d = JSON.parse(token as any)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.changePassword
    }`;
    return this.http.put(url, param, { headers });
  }

  AddRatingReview(param: any): Observable<any> {
    const token = localStorage.getItem('token') as any;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.addRatingReview
    }`;
    return this.http.post(url, param, { headers });
  }

  chackOut(param: any): Observable<any> {
    const token = localStorage.getItem('token') as any;
    // const d = JSON.parse(token as any)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    const url = `${environment.apiBaseUrl + environment.apiEndPoint.checkOut}`;
    this.cartClickInCheckOut.emit();
    return this.http.post(url, param, { headers });
  }

  getAddressById(addressId: string): Observable<any> {
    const token = localStorage.getItem('token') as string;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    const url = `${environment.apiBaseUrl}${environment.apiEndPoint.getAddressById}/${addressId}`;
    return this.http.get(url, { headers });
  }

  getAllUserAddress(): Observable<any> {
    const token = localStorage.getItem('token') as string;
    // const d = JSON.parse(token as any)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.getAllUserAddress
    }`;
    return this.http.get(url, { headers });
  }

  getAllCategories(): Observable<any> {
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.getAllCategories
    }`;
    return this.http.get(url);
  }

  deleteAddressById(addressId: string): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    const url = `${environment.apiBaseUrl}${environment.apiEndPoint.deleteAddressById}/${addressId}`;
    return this.http.delete(url, { headers });
  }

  addAddress(param: any): Observable<any> {
    const token = localStorage.getItem('token') as any;
    // const d = JSON.parse(token as any)
    const headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.addAddress
    }`;
    return this.http.post(url, param, { headers });
  }

  getStateByCountry(Country: any) {
    const url = `${environment.apiBaseUrl + environment.apiEndPoint.getStates}`;
    return this.http.post(url, Country);
  }
  PhonepePayment(param: any) {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'X-VERIFY': `1110e8ae4d50e1c37f18f045a1e8b472663e8d075b40ef49e67f3ee7317464c5###1`,
    });
    const url = `https://tribe-pi.vercel.app/api/phonepe-payment`;
    return this.http.post(url, param, { headers });
  }

  getUserByToken(): Observable<any> {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No token found in localStorage');
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    const url = `${environment.apiBaseUrl}${environment.apiEndPoint.getUserDetail}`;

    return this.http.get(url, { headers });
  }

  getOrdersList(page: number = 1, limit: number = 10): Observable<any> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());

    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    const url = `${environment.apiBaseUrl}${environment.apiEndPoint.getOrdersList}`;

    return this.http.get(url, { headers, params });
  }

  // // In your ApiServiceService
  // getOrdersList(page: number = 1, limit: number = 10): Observable<any> {
  //   const params = new HttpParams()
  //     .set('page', page.toString())
  //     .set('limit', limit.toString());

  //   return this.http.get(`${this.apiUrl}/orders`, { params });
  // }

  setDefaultAddress(address_id: string): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    const url = `${environment.apiBaseUrl}${environment.apiEndPoint.defaultDeliveryAddress}/${address_id}`;
    return this.http.post(url, {}, { headers });
  }

  getOrderById(id: any): Observable<any> {
    const token = localStorage.getItem('token') as any;
    // const d = JSON.parse(token as any)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.getOrderById
    }/${id}`;
    return this.http.get(url, { headers });
  }

  logOut() {
    const token = localStorage.getItem('token'); // Ensure this retrieves the correct token
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = `${environment.apiBaseUrl + environment.apiEndPoint.logOut}`;
    return this.http.get(url, { headers });
  }

  // addWishlist(param: any): Observable<any> {
  //   const token = localStorage.getItem('token');
  //   const headers = new HttpHeaders({
  //     'Authorization': `Bearer ${token}`,
  //   });
  //   const url = `${environment.apiBaseUrl+environment.apiEndPoint.addWishlist}`;
  //   return this.http.post(url, param,{headers});
  // }

  addWishlist(productId: string): Observable<any> {
    const token = localStorage.getItem('token'); // Ensure this retrieves the correct token
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.addWishlist
    }`;

    return this.http.post(url, { product_id: productId }, { headers });
  }

  getWishlist(): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.getWishlist
    }`;
    this.wishlistClick.emit();
    return this.http.get(url, { headers });
  }

  // removeWishlist(param: any): Observable<any> {
  //   const token = localStorage.getItem('token');
  //   const headers = new HttpHeaders({
  //     'Authorization': `Bearer ${token}`,
  //   });
  //   const url = `${environment.apiBaseUrl+environment.apiEndPoint.removeWishlist}`;
  //   return this.http.delete(url, param,{headers});
  // }

  // Method to remove product from wishlist
  removeWishlist(productId: String): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.removeWishlist
    }/${productId}`;

    return this.http.delete(url, { headers });
  }

  applyCoupon(param: any): Observable<any> {
    const token = localStorage.getItem('token') as any;
    // const d = JSON.parse(token as any)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.applyCoupon
    }`;
    return this.http.post(url, param, { headers });
  }

  updateReward(param: any): Observable<any> {
    const token = localStorage.getItem('token') as any;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.updateReward
    }`;

    return this.http.post(url, param, { headers });
  }

  updateProfile(param: any): Observable<any> {
    const token = localStorage.getItem('token') as any;
    // const d = JSON.parse(token as any)
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.updateProfile
    }`;
    return this.http.post(url, param, { headers });
  }

  // orderCancel(orderId: string, payload: any): Observable<any> {
  //   const token = localStorage.getItem("token") as string;
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'Authorization': `Bearer ${token}`
  //   });

  //   const url = `${environment.apiBaseUrl}/order-cancel/${orderId}`;

  //   return this.http.post(url, payload, { headers });
  // }

  orderCancel(
    orderId: string,
    payload: any,
    videoFile?: File,
  ): Observable<any> {
    const token = localStorage.getItem('token') as string;

    const formData = new FormData();
    formData.append('selectedChoice', payload.selectedChoice);
    if (payload.otherIssue) {
      formData.append('otherIssue', payload.otherIssue);
    }
    if (videoFile) {
      formData.append('video', videoFile); // must match `upload.single('video')` in backend
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const url = `${environment.apiBaseUrl}/order-cancel/${orderId}`;
    return this.http.post(url, formData, { headers });
  }

  addBankInfo(param: any): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token || ''}`,
    });

    const url = `${environment.apiBaseUrl}/add-user-bank`; // ✅ use the real backend route
    return this.http.post(url, param, { headers });
  }

  getBankInfo(userId: string): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token || ''}`,
    });
    const url = `${environment.apiBaseUrl}/get-user-bank/${userId}`;
    return this.http.get(url, { headers });
  }

  getRecentlyViewedProducts(userId: string): Observable<any> {
    const token = localStorage.getItem('token'); // or wherever you store the token
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const url = `${environment.apiBaseUrl}user/${userId}/recently-viewed-products`;
    return this.http.get<any>(url, { headers });
  }

  // Method to fetch similar products
  getSimilarProducts(productId: string): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    // Correct URL structure
    return this.http.get<any>(
      `${environment.apiBaseUrl}/product/${productId}/similar`,
      { headers },
    );
  }

  searchProducts(
    searchTerm: string,
    page: number = 1,
    limit: number = 12,
  ): Observable<any> {
    const params = new HttpParams()
      .set('search', searchTerm)
      .set('page', page.toString())
      .set('limit', limit.toString());

    return this.http.get(
      `${environment.apiBaseUrl + environment.apiEndPoint.prodcutSearch}`,
      { params },
    );
  }

  // Fetch all order transactions
  allOrderTransaction(): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem('token')}`, // Assumes token is stored in localStorage
    });

    return this.http.get(
      `${environment.apiBaseUrl + environment.apiEndPoint.allOrderTransaction}`,
      { headers },
    );
  }

  // Fetch all user reviews o product
  userReviews(): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem('token')}`, // Assumes token is stored in localStorage
    });

    return this.http.get(
      `${environment.apiBaseUrl + environment.apiEndPoint.userReviews}`,
      { headers },
    );
  }

  // Fetch discounted products
  getDiscountedProducts(): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/product-discount`);
  }
  // Fetch discounted products
  getDiscountedOnFashionProducts(): Observable<any> {
    return this.http.get(
      `${environment.apiBaseUrl}/product-discount-on-fashion`,
    );
  }
  // Fetch discounted products
  discountonelectronic(): Observable<any> {
    return this.http.get(
      `${environment.apiBaseUrl}/product-discount-on-electronic`,
    );
  }

  popularProdut(): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/popular-products`);
  }

  newArrivalsProduct(): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/new-arrivals`);
  }

  getDiscountedOnFurnitureProducts(): Observable<any> {
    return this.http.get(
      `${environment.apiBaseUrl}/product-discount-on-furniture`,
    );
  }

  initiatePayment(payload: any): Observable<any> {
    return this.http.post(
      `${environment.apiBaseUrl}phonepe/initiate-payment`,
      payload,
    );
  }

  createCashFreeOrder(payload: any) {
    return this.http.post(
      `${environment.apiBaseUrl}payment/create-order`,
      payload,
    );
  }

  checkStatus(orderId: string): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}check-status/${orderId}`);
  }

  verifyCashFreeOrder(orderId: string) {
    return this.http.post(`${environment.apiBaseUrl}/payment/verify`, {
      orderId,
    });
  }

  // Method to get the estimated delivery date
  getEstimatedDeliveryDate(deliveryType: string): Observable<any> {
    const url = `${environment.apiBaseUrl}estimated-delivery-date/?deliveryType=${deliveryType}`;
    return this.http.get(url);
  }

  getSellerStoreDetails(sellerId: any): Observable<any> {
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.sellerStoreDetails
    }/${sellerId}/details`;
    return this.http.get(url);
  }
  getSellerReviews(sellerId: any): Observable<any> {
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.sellerStoreDetails
    }/${sellerId}/reviews`;
    return this.http.get(url);
  }
  getSellerAvgRating(sellerId: any): Observable<any> {
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.sellerStoreDetails
    }/${sellerId}/average-rating`;
    return this.http.get(url);
  }
  getSellerCategories(sellerId: any): Observable<any> {
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.sellerCategory
    }/${sellerId}/categories`;
    return this.http.get(url);
  }
  getSellerAllProduct(sellerId: any): Observable<any> {
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.SellerProduct
    }/${sellerId}/products`;
    return this.http.get(url);
  }
  GetPopularProductsBySeller(sellerId: any): Observable<any> {
    const url = `${
      environment.apiBaseUrl +
      environment.apiEndPoint.GetPopularProductsBySeller
    }/${sellerId}`;
    return this.http.get(url);
  }
  GetNewlyArrivedProductsBySeller(sellerId: any): Observable<any> {
    const url = `${
      environment.apiBaseUrl +
      environment.apiEndPoint.getSellerNewlyArrivedProducts
    }/${sellerId}`;
    return this.http.get(url);
  }
  GetTopQualityProductsBySeller(sellerId: any): Observable<any> {
    const url = `${
      environment.apiBaseUrl +
      environment.apiEndPoint.getSellerTopQualityProducts
    }/${sellerId}`;
    return this.http.get(url);
  }
  GetBestOfferProductsBySeller(sellerId: any): Observable<any> {
    const url = `${
      environment.apiBaseUrl +
      environment.apiEndPoint.getSellerBestOfferProducts
    }/${sellerId}`;
    return this.http.get(url);
  }

  // Fetch best-selling products
  getBestSellingProducts(): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/GetBestSellingProducts`);
  }

  GetTopQualityProducts(): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/GetTopQualityProducts`);
  }

  // Method to cancel an order item
  cancelOrderItem(orderId: string, itemId: string): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const url = `${environment.apiBaseUrl}/order/${orderId}/cancel-item/${itemId}`;
    return this.http.put(url, null); // Use PUT request to cancel the item
  }

  // fetchWaybill(count: number): Observable<any> {
  //   // Construct the URL with the count parameter included
  //   const url = `${environment.apiBaseUrl}/fetch-waybill?count=${count}`;
  //   return this.http.get(url);
  // }

  // API Service methods
  sendWhatsappOtp(phoneNumber: string) {
    return this.http.post(`${environment.apiBaseUrl}/send-wp-otp`, {
      phoneNumber,
    });
  }

  checkMobileExists(mobile: string) {
    return this.http.post(`${environment.apiBaseUrl}check-mobile`, { mobile });
  }

  verifyWhatsappOtp(phoneNumber: string, otp: string) {
    return this.http.post(`${environment.apiBaseUrl}/verify-wp-otp`, {
      phoneNumber,
      otp,
    });
  }

  raiseTicket(formData: FormData): Observable<any> {
    const token = localStorage.getItem('token'); // Retrieve the token from localStorage
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`, // Add the token to the Authorization header
    });

    return this.http.post(`${environment.apiBaseUrl}/raise-ticket`, formData, {
      headers, // Include the headers
      reportProgress: true, // Enable progress reporting for file uploads
      observe: 'events', // Observe all events (e.g., progress, response)
    });
  }

  getTrackingInfo(waybill: string): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const params = new HttpParams().set('waybill', waybill);

    return this.http.get(`${environment.apiBaseUrl}track-order`, {
      headers,
      params,
    });
  }

  generateSingleInvoice(orderId: string): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    const body = { orderId };

    return this.http.post(
      `${environment.apiInvoiceUrl}/generate-single-invoice`,
      body,
      { headers },
    );
  }

  forgotPassword(email: string): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/forget-password`, {
      email,
    });
  }

  resetPassword(token: string, newPassword: string): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/reset-password/${token}`, {
      newPassword,
    });
  }

  trackOrderById(orderId: string): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/track-all-order`, {
      params: { orderId },
    });
  }

  // ✅ New: Search suggestions API
  searchSuggestions(query: string): Observable<any> {
    return this.http.get<any>(`${environment.apiBaseUrl}/search-suggestions`, {
      params: { q: query },
    });
  }
  getReviewsByProduct(productId: string): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}reviews/${productId}`);
  }

  // ✅ Fetch Delhivery Pincode Details
  getPincodeDetails(pincode: string): Observable<any> {
    const url = `${environment.apiBaseUrl}/pin-codes?parameters=${pincode}`;
    return this.http.get(url);
  }

  submitReturnRequest(formData: FormData) {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    // Note: Do NOT set Content-Type manually when using FormData
    // HttpClient will set it automatically with the correct boundary

    return this.http.post(`${environment.apiBaseUrl}return`, formData, {
      headers,
    });
  }

  // getProductBySlug(slug: string, userId?: string) {
  //   return this.http.get(`${environment.apiBaseUrl}/product/slug/${slug}`, { params: { userId } }).pipe(
  //     map((res: any) => ({ data: res })) // wrap manually
  //   );
  // }

  getProductIdBySlug(slug: string) {
    return this.http.get(`${environment.apiBaseUrl}/product/slug/${slug}`);
  }

  getCategoryPath(id: string) {
    return this.http.get<{
      success: boolean;
      path: { id: string; name: string }[];
    }>(`${environment.apiBaseUrl}/categories/path/${id}`);
  }

  sponsoredProduct(): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/sponsored-product`);
  }

  // productImpression(productId: string): Observable<any> {
  //   return this.http.post(
  //     `${environment.apiBaseUrl}/impression`,
  //     { productId }
  //   );
  // }

  productClick(productId: string): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return this.http.post(
      `${environment.apiBaseUrl}/click`,
      { productId },
      { headers },
    );
  }

  getProductsByIds(ids: string[]) {
    return this.http.post<any[]>(
      `${environment.apiBaseUrl}/products-browsing/by-ids`,
      { productIds: ids },
    );
  }

  askQuestion(data: any) {
    const token = localStorage.getItem('token');

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return this.http.post(`${environment.apiBaseUrl}/ask-question`, data, {
      headers,
    });
  }

  getProductQuestions(productId: string) {
    return this.http.get<any>(
      `${environment.apiBaseUrl}/get-response/${productId}/questions`,
    );
  }

  createRazorpayOrder(amountInPaise: number, receipt?: string) {
    return this.http.post<any>(`${environment.apiBaseUrl}/create-order`, {
      amount: amountInPaise,
      currency: 'INR',
      receipt,
    });
  }

  verifyRazorpayPayment(payload: {
    razorpay_order_id: string;
    razorpay_payment_id: string;
    razorpay_signature: string;
  }) {
    return this.http.post<any>(
      `${environment.apiBaseUrl}/verify-payment`,
      payload,
    );
  }
}
